import { render, staticRenderFns } from "./ReqImagePreview.vue?vue&type=template&id=cb385bfe&scoped=true"
import script from "./ReqImagePreview.vue?vue&type=script&lang=js"
export * from "./ReqImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ReqImagePreview.vue?vue&type=style&index=0&id=cb385bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb385bfe",
  null
  
)

export default component.exports